import * as TerrassorConst from '../../../../terrassor_const.js'

// import { set_Terrassor_INTERFACE, get_Terrassor_INTERFACE } from "../../../../interface.js";
import { set_Terrassor_INTERFACE, get_Terrassor_INTERFACE, Terrassor_RECALCULATE } from "../../../../interface.js";



/* @ngInject */
export class InstallationController {
  /* @ngInject */
  constructor (ApiConst, ApiSimu, ApiExo, TerrassorDB, $scope, $filter, $q) {
    this.$scope = $scope
    this.$q = $q
    this.$filter = $filter
    this.ApiConst = ApiConst
    this.ApiSimu = ApiSimu
    this.ApiExo = ApiExo
    this.TerrassorDB = TerrassorDB
      this.ready = 0 // BC

    this.inhib = false;

    
    // pour contourner les bindings inutiles
    this.ignore = this.ignore.bind(this) 
}


  $onInit () {

    console.log('InstallationController : init')

    //console.log('MouvementController --> require ^^simulator', this.parentSimulator)

    this.consigne = 'texte de consigne'
    this.warning = 'texte de warning'

    this.detailSelectedEquipement = null
    this.formattedDetails = null

    // addNew ou getcurrent installation
    return this.addInstallation(TerrassorConst.CURRENT_ETUDE_ID)
    .then( _ => {
      this.prepareInitialData() // liste des équipements pour le sélecteur (<=> famille)
      this.isAdding = false

    })


  }

/*
* Pour les bindings inutiles
*/
  ignore(obj) { console.log('InstallationController::ignore', obj)  }

  /*
* Nouvelle installation (si non créée pour l'étude courante)
*/
addInstallation(etudeId) {

    return this.ApiSimu.installationExists(etudeId) 
    .then(row => {
console.log('addInstallation : après installationExists : ', row);
      if(!row)
        return this.ApiSimu.newInstallation(etudeId) // renvoie la Promise de la ligne insérée 
      else
        return this.$q.resolve(row) // renvoie la Promise de ligne existante

    })
    .then(insertedRow => {      
      // usage de linstallation_id pour l'ajout futur des equipements
      this.currentInstallation = insertedRow
      // checkbox "installation valide"
      this.parentSimulator.installationValid = this.valid = this.currentInstallation.valide ? true : false
      // checkbox "installation inhibe"
      this.parentSimulator.installationInhib = this.inhib = this.currentInstallation.inhibe ? true : false

      console.log('InstallationController::addInstallation, valid:', this.currentInstallation, this.valid)
      console.log('InstallationController::addInstallation, inhib:', this.currentInstallation, this.inhib)
      return this.$q.resolve(this.valid)
    })
}

/*
* Non modifiable si l'animation a démarré (i.e. le jour atteint est > 0)
*/
isReadOnly() {
  //this.parentSimulator.nbJoursAtteints = 0 // TMP BC uniquement si blocage lors du debug
return(this.parentSimulator.animationIsPlaying) // BC
//   return (this.parentSimulator.nbJoursAtteints > 0)
}


/*  checkbox "installation valide pour la simulation"
* Màj de l'install dans la base autre vérifs à faire ???
*/
  doOnCheckValid(forceValue) {

    if(forceValue !== undefined) // can bue true | false
      this.valid = forceValue
    
    var selected = this.valid

    this.currentInstallation.valide = selected ? 1 : 0
    //return this.ApiSimu.saveInstallation(this.currentInstallation)
    return this.TerrassorDB.saveRowInTable(this.currentInstallation, "simu_installations")        
    .then( _ => {

      this.parentSimulator.installationValid = this.currentInstallation.valide
      this.parentSimulator.checkAllMouvementsValid()  // on pourrait aller plus vite si selected == false ...
    })

  }

/*  checkbox "installation inhibée pour la simulation partielle" */
doOnCheckInhib() {

    var selected = this.inhib

    this.currentInstallation.inhibe = selected ? 1 : 0

      // BC on passe l'info au backend (et on stocke l'analyse ?)
    var retour =  get_Terrassor_INTERFACE().action({"table":"simu_analyses", "inhibe":this.currentInstallation.inhibe})
    // this.ApiSimu.saveAnalyse(retour.objet)   // on stocke l'analyse ?

    return this.TerrassorDB.saveRowInTable(this.currentInstallation, "simu_installations")
    .then( _ => {
        this.parentSimulator.installationInhib = this.currentInstallation.inhibe

        // var retour = Terrassor_RECALCULATE(); // car le cochage change la date de fin (restauration de l'installation de chantier)

        // et on referme l'installation
        // et on permet le passage à la simulation
        this.parentSimulator.checkAllMouvementsValid()  // si je comprends bien c'est par ce biais que les messages sont affichés ...
    })

  }

doOnMagic() {


    console.log('doOnMagic Installation ', this.resource)

    this.setPropertiesForPrevisionnel() // BC reinit


    this.valid = false
    this.currentInstallation.valide = false
    this.inhib = false
    this.currentInstallation.inhibe = false
    return this.TerrassorDB.saveRowInTable(this.currentInstallation, "simu_installations")
    .then( _ => {
      this.parentSimulator.installationValid = this.currentInstallation.valide
      this.parentSimulator.installationInhib = this.currentInstallation.inhibe
    })

  }


  /*
  * Détail sur un type d'installation (presta ou equipt)
*/
doOnSelectEquipement1() {
    this.selectedEquipementId2="0"
    this.selectedEquipementId3="0"
    this.doOnSelectEquipement(this.selectedEquipementId1)
}
doOnSelectEquipement2() {
    this.selectedEquipementId1="0"
    this.selectedEquipementId3="0"
    this.doOnSelectEquipement(this.selectedEquipementId2)
}
doOnSelectEquipement3() {
    this.selectedEquipementId1="0"
    this.selectedEquipementId2="0"
    this.doOnSelectEquipement(this.selectedEquipementId3)
}
doOnSelectEquipement(id123) {

  var id = id123
  return this.TerrassorDB.readRowInTable(id, 'const_installations')
  .then(equipt => {
      if (typeof(equipt) != 'undefined') {
        this.selectedEquipement = equipt
        this.setImageEquipement(equipt)
        this.formatDetailsEquipement(equipt)

        this.quantification = equipt.quantification // pour le mode bolléen / numérique
    
        // update de la consigne
        this.defineConsigne()
      }
      
    })
  
}

/*
*
*/

setImageEquipement(equipt) {
  var iPath = 'images/equipements/' + equipt.code.toLowerCase() + '_grey.svg'  
  this.selectedEquipement.image = iPath


}


formatDetailsEquipement(e) {
  var formatted = [];
  var labels = []
  var value

  labels['nom'] = {'label': 'Informations', 'unit':''}
  //labels['libelle_court'] = {'label': 'Nom', 'unit':''}
  labels['regle'] = {'label': 'Détail', 'unit':''}
  labels['nb_personnes'] = {'label': 'Nombre de personnes associées', 'unit':''}
  labels['duree_installation'] = {'label': 'Durée', 'unit':' j'}

  labels['cout_fixe'] = {'label': 'Coût fixe', 'unit':' €'}
  labels['cout_fixe_ml'] = {'label': 'Coût fixe par mètre', 'unit':' €'}
  labels['cout_jour'] = {'label': 'Coût journalier', 'unit':' €'}
  labels['cout_mois'] = {'label': 'Coût mensuel', 'unit':' €'}
  labels['cout_mois_km'] = {'label': 'Coût mensuel par km', 'unit':' €'}
  
  for(var key in labels) {
    if(e[key])
      {
      if(typeof(e[key]) == 'number')
        value = this.$filter('number')(e[key])
      else
        value = e[key]
      formatted.push({"label":labels[key].label, "value":value + labels[key].unit })
     }
  }
  

    
    /*formatted.push( {"label":"Informations", "value":e.nom})
    formatted.push( {"label":"Coût fixe", "value":e.cout_fixe})
    formatted.push( {"label":"Coût variable", "value":e.cout_variable})*/
    this.formattedDetails = formatted;
  }



 /*
  * obtention de la liste de ttes les installations (prestas & equipements)
  * pour peuplement du select
  */
  prepareInitialData () {

    console.log('prepareInitialData')

    var list;
    this.quantity = 0
    this.allConstInstallations1 = []
    this.allConstInstallations2 = []
    this.allConstInstallations3 = []

    return this.ApiConst.getAllInstallations()
    .then(list => {
        this.allConstInstallations = list
        list.forEach(inst => {
            switch (inst.groupe) {
                case 1:
                    this.allConstInstallations1[this.allConstInstallations1.length] = inst;
                    break;
                case 2:
                    this.allConstInstallations2[this.allConstInstallations2.length] = inst;
                    break;
                case 3:
                    this.allConstInstallations3[this.allConstInstallations3.length] = inst;
                    break;
              }
        })
      return this.$q.resolve(this.AllConstInstallations)
     })
    .then(_ => {
      return this.refreshListEquipements(0)
    })

  }


  /*
  */
  refreshListEquipements(recalculate) {

      if (recalculate) { // BC 2018 : bon ben la ligne dessous génère un bug si elle est appellée à l'init - donc condition ...
        var retour = Terrassor_RECALCULATE(); // BC 2017/12 - le calcul n'était pas lancé lors des modifs de l'installation !!!!
        // je ne sais pas si c'est ici qu'il faut le faire, mais sinon je ne vois pas où ...
      }

    console.log('InstallationController::refreshListEquipements')

    return this.ApiSimu.getAllEquipements()
    .then(results => {
      console.log('InstallationController::refreshListEquipements, results', results)
      this.equipements = this.formatCurrentSelection(results)
      this.defineConsigne()
      this.setPropertiesForPrevisionnel()
    
    })
  }

/*
* PropertiesList "previsionnel"
*/
  setPropertiesForPrevisionnel() {

      var retour = get_Terrassor_INTERFACE().action({"table":"simu_installations_const_installations", "read":{"previsionnel":"1"}});
      if(retour.retour == "false" || retour.retour == false) {
            // previsionnel invalide  
            this.previsionnel = [
            { label: "Coût Total", value: ''}, 
            { label: "Delai", value: ''}
              ];
            this.occupation = [
            { label: "Personnes", value: ''},
            { label: "Engins", value: ''}
              ];
            return 
      }

    var result = retour.objet
    console.log("InstallationController::setPropertiesForPrevisionnel, after read ", result);

    this.previsionnel = [
      { label: "Coût", value: this.$filter('currency')(result.coutPrevisionnel)}, 
      { label: "Délai", value: result.delaiPrevisionnel + ' j'}
    ];
    this.occupation = [
      { label: "Personnes", value: result.nbPersonnes},
      { label: "Engins", value: result.nbEngins}
    ];
  }


  // consignes du panel installation
  defineConsigne () {
    var msg

    if(this.isAdding)
      {this.consigne = ''; return }

    if(!this.allEquipements || this.allEquipements.length == 0) {
      msg = 'Commencez par choisir un équipement ou une prestation puis indiquez la quantité nécessaire au chantier'
      this.consigne= msg
      return msg
    }
    else {
      msg = 'Cliquez sur "Ajouter un équipement ou une prestation" autant de fois que souhaité'
      this.consigne= msg
      return msg

    }    
  }


/*
* Toggle mode add / edit
*/
showAddEquipement () { this.isAdding = true }

hideAddEquipement () { this.isAdding = false; this.selectedEquipement = undefined }
  
/*
* force la valeur saisie >=0
*/
  isDataValid() {
    if(!this.selectedEquipement)
      return false

    if(this.quantification == false) // cas des sélections par booléen
      this.quantity = 1

    this.quantity = Math.max(this.quantity, 0)  // s'assurer qu'on a bien une valeur >=0
    return (this.quantity > 0)
  }

  /*
  *   Enregistrement equipement ou prestation. UN seul objet !!! (<> engins)
  */
  validate() {

      // BC il y a une modif donc le dit au backend
    var retour =  get_Terrassor_INTERFACE().action({"table":"simu_analyses", "topDateEtude":[]})
    this.ApiSimu.saveAnalyse(retour.objet)

    var equipements = this.createEquipementsListFromSelection() // désérialiser le résultat avec "quantity"

    console.log('InstallationController::validate, ready to add All  ', equipements)

    return this.addEquipements(equipements)
    .then(_ => {
      // this.defineConsigneEchelons()
      console.log('InstallationController::validate, calling doRefreshInstallation')
      this.refreshListEquipements(1)
      this.reset()
      this.hideAddEquipement()    
      // installation doit être a nouveau validée
      this.doOnCheckValid(false)
    })
  }

/*
*
*/
cancel() {
    this.reset()
    this.hideAddEquipement()    
    this.defineConsigne()
  }

/*
* Ici, c'est simplissime ....
*/
createEquipementsListFromSelection() {
  var selectionEquipement
  var quantity

   /* if(this.phaseHasReusablesSelected(phaseSelection))
        quantity = 0
    else*/
      quantity = this.quantity
    // pour cette phase, on construit la liste des engins
        selectionEquipement =
           {
            'simu_installations_id': this.currentInstallation.id, // défini au $init
            'const_installations_id':  this.selectedEquipement.id, 
            'quantite':  this.quantity
            }
        //console.log('AddEnginController::createEnginsListFromSelectionPhase, ready to add engins X ', phaseSelection.code, quantity, selectionEngins)
            
    return selectionEquipement
}

/*
* le push (vers interface) est fait dans ApiSimu
*/

  addEquipements(eqts) {    

     return this.ApiSimu.saveNewEquipments(eqts, eqts.simu_installations_id)
      .then(allResults => {
      console.log('InstallationController::addEquipements, all added', allResults)
      return allResults
    })
    .then(_ => {
         this.ready = 1
    })
   
  }

 /*
 */
 deleteEquipements (eqts) {
    console.log('InstallationController::deleteEquipements asked', eqts)

    return this.TerrassorDB.deleteRowInTable(eqts.id, 'simu_installations_const_installations')
    .then( _ => {
      get_Terrassor_INTERFACE().action({"table":"simu_installations_const_installations", "delete":{"id": eqts.id}});
      // installation doit être a nouveau validée
      this.doOnCheckValid(false)

    })
  }


  /*
  * Suppression de toutes les installations (equipements)d'un groupe. Raffraichissement de la liste après coup 
  *
   */
  deleteGroupInstalations (group) {

// groupEngins.modelEngin.const_famillesengins_nom
      var nomInstall = "wiz"
    var messageConfirmation = "Vous allez retirer "+group.quantity+" item(s) '"+group.installations[0].nom+"'.\nEtes-vous sûr de vouloir réaliser cette opération ?";
    if(!confirm(messageConfirmation)) {
        return;
    }

      // BC il y a une modif donc le dit au backend
    var retour =  get_Terrassor_INTERFACE().action({"table":"simu_analyses", "topDateEtude":[]})
    this.ApiSimu.saveAnalyse(retour.objet)

    console.log('InstallationController::deleteGroupInstalations asked', group)

    var allPromises = []
    group.installations.forEach(inst => {
        var promise = this.deleteEquipements(inst)
        allPromises.push(promise)
    })
    // raffraichir une fois que toutes les queries sont résolues  
    return Promise.all(allPromises)
    .then(allResults => {
      return this.refreshListEquipements(1)
    })
    .then( _ => {
      return console.log('InstallationController::refreshListEquipements done', this.formattedEnginsList)
    })

  }


/*
* Pour affichage de la liste des équipements actuels
*/
formatCurrentSelection(results) {

var currentEquipements = []
var groups = []
var groupedInstallations = [] // sert pour la gestion
var groupedInstallations1 = []
var groupedInstallations2 = []
var groupedInstallations3 = []
var groupeTitres = []

results.forEach(e => {
  var eqpt = {}
  eqpt.nom = e.const_installations.libelle_court
  eqpt.code = e.const_installations.code
  eqpt.quantity = e.simu_installations_const_installations.quantite
  eqpt.image = 'images/equipements/' + e.const_installations.code.toLowerCase() + '_grey.svg'  
  eqpt.id = e.simu_installations_const_installations.id // pour le delete
  eqpt.groupe = e.const_installations.groupe
  eqpt.groupeLibelle = e.const_installations.groupe_libelle

  currentEquipements.push(eqpt)
})


// regroupement par type dequipement/prestation
  currentEquipements.forEach(e=> {
      // ajout nelle entrée  (type-option-godet)
      var code = e.code
      //var code = e.const_engins_code
      if(!groups[code]) {
          groups[code] = {'const_installations_code': code, 'installations' : [], 'nb' : 0, 'quantity':0}
        }
      groups[code].installations.push(e)
      groups[code].nb += 1
      groups[code].quantity += e.quantity
      groups[code].groupe = e.groupe
      groups[code].groupeLibelle = e.groupeLibelle
  })

  // transform associative en indexed (sinon on ne peut pas le manipuler aisément dans la vue)
  for( var key in groups) {
    var g = groups[key]
    var item = {'const_installations_code' : g.const_installations_code, 'nb' : g.nb, 'quantity':g.quantity, 'installations':g.installations, 'modelInstallations':g.installations[0]  }
    groupedInstallations.push(item)
    if (g.groupe == 1) {
        groupedInstallations1.push(item)
        groupeTitres[g.groupe] = g.groupeLibelle
    }
    if (g.groupe == 2) {
        groupedInstallations2.push(item)
        groupeTitres[g.groupe] = g.groupeLibelle
    }
    if (g.groupe == 3) {
        groupedInstallations3.push(item)
        groupeTitres[g.groupe] = g.groupeLibelle
    }
  }

this.allEquipements = groupedInstallations
this.allEquipements1 = groupedInstallations1
this.allEquipements2 = groupedInstallations2
this.allEquipements3 = groupedInstallations3
this.groupeTitres = groupeTitres
}


/*
*
*/
  resetViewVars() {
    this.quantity = 0
    this.selectedEquipementId=0
    this.selectedEquipementId1="0"
    this.selectedEquipementId2="0"
    this.selectedEquipementId3="0"
  }

  /*
  *
  */
  reset() {
    this.resetViewVars
    this.isAdding = false
    this.selectedEquipement = false
    this.quantity = 0
  }

  removeConsigne () {
    this.consigne = ''
  }

  getConsigne() {
    return this.consigne
  }

  
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/installation/installation.controller.js